import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainEditDeviceSocketSize(data) {
  return maintainRequest({
    url: `/device/maintenanceMan/chargingPile/editDeviceSocketSize`,
    method: "post",
    data,
  });
}
